import { render, staticRenderFns } from "./PageDrawer.vue?vue&type=template&id=3e15d9d4&"
import script from "./PageDrawer.vue?vue&type=script&lang=js&"
export * from "./PageDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports